import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
  } from 'react';

export const getSiNoFilterComponent = () => {
  function SiNoFilter() {
  }

  SiNoFilter.prototype.init = function(params) {
      this.eGui = document.createElement('div');
      this.eGui.innerHTML = '<select ><option value="">Todo</option><option value="true">Sí</option><option value="false">No</option></select>';
      this.currentValue = null;
      this.eFilterInput = this.eGui.querySelector('select');
      var that = this;

      function onInputBoxChanged() {
          if (that.eFilterInput.value === '') {
              params.parentFilterInstance(function(instance) {
                  instance.onFloatingFilterChanged(null, null);
              });
              return;
          }

          that.currentValue = that.eFilterInput.value;
          params.parentFilterInstance(function(instance) {
              instance.onFloatingFilterChanged('equals', that.currentValue);
          });
      }

      this.eFilterInput.addEventListener('change', onInputBoxChanged);
  };

  SiNoFilter.prototype.onParentModelChanged = function(parentModel) {
      if (!parentModel) {
          this.eFilterInput.value = '';
          this.currentValue = null;
      } else {
          this.eFilterInput.value = parentModel.filter + '';
          this.currentValue = parentModel.filter;
      }
  };

  SiNoFilter.prototype.getGui = function() {
      return this.eGui;
  };

  return SiNoFilter;
}

// export const getSiNoNuloFilterComponent = () => {
//     function SiNoNuloFilter() {
//     }
  
//     SiNoNuloFilter.prototype.init = function(params) {
//         this.eGui = document.createElement('div');
//         this.eGui.innerHTML = '<select ><option value="">Todo</option><option value="true">Sí</option><option value="false">No</option><option value="null">Sin Dato</option></select>';
//         this.currentValue = null;
//         this.eFilterInput = this.eGui.querySelector('select');
//         var that = this;
  
//         function onInputBoxChanged() {
//             if (that.eFilterInput.value === '') {
//                 params.parentFilterInstance(function(instance) {
//                     instance.onFloatingFilterChanged(null, null);
//                 });
//                 return;
//             }
  
//             that.currentValue = that.eFilterInput.value;

//             // if (that.eFilterInput.value === 'null') {
//             // //     console.log('paraaaaams ', params)
//             //     let gridApi = params.api;
//             // //     let columnId = params.filterParams.column.colId
//             //     params.parentFilterInstance(function(instance) {
//             //         instance.onFloatingFilterChanged('contains', '');
//             //     });
                
//             //     gridApi.onFilterChanged()
//             // }else{
//                 params.parentFilterInstance(function(instance) {
//                     instance.onFloatingFilterChanged('equals', that.currentValue);
//                 });
//             //}
//         }
  
//         this.eFilterInput.addEventListener('change', onInputBoxChanged);
//     };
  
//     SiNoNuloFilter.prototype.onParentModelChanged = function(parentModel) {
//         if (!parentModel) {
//             this.eFilterInput.value = '';
//             this.currentValue = null;
//         } else {
//             this.eFilterInput.value = parentModel.filter + '';
//             this.currentValue = parentModel.filter;
//         }
//     };
  
//     SiNoNuloFilter.prototype.getGui = function() {
//         return this.eGui;
//     };
  
//     return SiNoNuloFilter;
//   }
  

export const getEstadoFilterComponent = () => {
  function EstadoFilter() {
  }

  EstadoFilter.prototype.init = function(params) {
      this.eGui = document.createElement('div');
      this.eGui.innerHTML = `<select><option value="">Todo</option><option value=1>Sin Validar</option><option value=2>Área</option>
      <option value=3>Fiscal</option><option value=4>Facturación</option><option value=5>Fin Semana</option></select>`;
      this.currentValue = null;
      this.eFilterInput = this.eGui.querySelector('select');
      var that = this;

      function onInputBoxChanged() {
          if (that.eFilterInput.value === '') {
              params.parentFilterInstance(function(instance) {
                  instance.onFloatingFilterChanged(null, null);
              });
              return;
          }

          that.currentValue = that.eFilterInput.value;
          params.parentFilterInstance(function(instance) {
              instance.onFloatingFilterChanged('equals', that.currentValue);
          });
      }

      this.eFilterInput.addEventListener('change', onInputBoxChanged);
  };

  EstadoFilter.prototype.onParentModelChanged = function(parentModel) {
      if (!parentModel) {
          this.eFilterInput.value = '';
          this.currentValue = null;
      } else {
          this.eFilterInput.value = parentModel.filter + '';
          this.currentValue = parentModel.filter;
      }
  };

  EstadoFilter.prototype.getGui = function() {
      return this.eGui;
  };

  return EstadoFilter;
}

export const getTipoUsuarioFilterComponent = () => {
    function TipoUsuarioFilter() {
    }
  
    TipoUsuarioFilter.prototype.init = function(params) {

        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<select><option value="">Todo</option><option value="Estructura">Estructura</option><option value="Corporacion">Corporación</option></select>';
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        var that = this;
  
        function onInputBoxChanged() {
            if (that.eFilterInput.value === '') {
                params.parentFilterInstance(function(instance) {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }
  
            that.currentValue = that.eFilterInput.value;
            params.parentFilterInstance(function(instance) {
                instance.onFloatingFilterChanged('equals', that.currentValue);
            });
        }
  
        this.eFilterInput.addEventListener('change', onInputBoxChanged);
    };
  
    TipoUsuarioFilter.prototype.onParentModelChanged = function(parentModel) {
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    };
  
    TipoUsuarioFilter.prototype.getGui = function() {
        return this.eGui;
    };
  
    return TipoUsuarioFilter;
  }


export const SiNoFilterComponent = forwardRef((props, ref) => {
    
    const [currentValue, setCurrentValue] = useState(null);
    const inputRef = useRef(null);
 
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, () => {
        return {
            onParentModelChanged(parentModel) {
                // When the filter is empty we will receive a null value here
                if (!parentModel) {
                    inputRef.current.value = '';
                    setCurrentValue(null);
                } else {
                    inputRef.current.value = parentModel.filter + '';
                    setCurrentValue(parentModel.filter);
                }
            }
 
        }
    });
 
 
    const valueChanged = input => {
        if (input.target.value === '') {
            // clear the filter
            props.parentFilterInstance(instance => {
                instance.onFloatingFilterChanged(null, null);
            });
            return;
        }
 
        setCurrentValue(input.target.value);
        props.parentFilterInstance(instance => {
            instance.onFloatingFilterChanged('equals', input.target.value);
        });
    }
  
      return (
        <select ref={inputRef} onChange={(e)=> valueChanged(e)}>
          <option value=''>{`TODO`}</option>
          <option value='true'>
          {`SI`}
          </option>
          <option value='false'>
            {`NO`}
          </option>
        </select>
      );
})


export const SelectorFilter = forwardRef((props, ref) => {
    
    const [currentValue, setCurrentValue] = useState(null);
    const inputRef = useRef(null);


    useEffect(()=>{
        props.api.forEachNode((n,i)=> {const nod = n;})
    },[props.api])
 
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, () => {
        return {
            onParentModelChanged(parentModel) {
                // When the filter is empty we will receive a null value here
                if (!parentModel) {
                    inputRef.current.value = '';
                    setCurrentValue(null);
                } else {
                    inputRef.current.value = parentModel.filter + '';
                    setCurrentValue(parentModel.filter);
                }
            }
 
        }
    });
 
 
    const valueChanged = input => {
        if (input.target.value === '') {
            // clear the filter
            props.parentFilterInstance(instance => {
                instance.onFloatingFilterChanged(null, null);
            });
            return;
        }
 
        setCurrentValue(input.target.value);
        props.parentFilterInstance(instance => {
            instance.onFloatingFilterChanged('equals', input.target.value);
        });
    }
  
      return (
        <select ref={inputRef} onChange={(e)=> valueChanged(e)}>
          <option value=''>{`TODO`}</option>
          <option value='true'>
          {`SI`}
          </option>
          <option value='false'>
            {`NO`}
          </option>
        </select>
      );
})


export const getClassUsers = (params) =>{
        return {
            'sick-days-warning': (params) => {
            return params.data.fechaExpatriadoDesde!==null && params.data.fechaExpatriadoHasta===null;
        }}
}

